function buocChungTuThuMua() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Chứng từ thu mua",
      content:
        "Trang có 3 biểu chứng từ: Biểu 01 theo hộ nông dân (có lọc hộ), Biểu 02 theo nhân viên, Biểu 03 theo hợp tác xã. Mỗi biểu chọn khoảng ngày riêng và bấm “Lọc dữ liệu” mới tải.",
    },
    {
      target: "#tour-chung-tu-thu-mua-bieu01",
      title: "Bước 2 · Biểu 01 — Theo hộ nông dân",
      content:
        "Bảng kê chi tiết thu mua từ từng hộ — đủ CCCD/địa chỉ/ghi chú chứng từ đầu vào. Dùng kèm Bảng kê 01/TNDN để minh bạch nguồn gốc nông sản.",
      placement: "bottom",
    },
    {
      target: "#tour-chung-tu-thu-mua-loc-bieu01",
      title: 'Bước 3 · Phải bấm "Lọc dữ liệu"',
      content:
        'Chọn khoảng ngày rồi BẤM "Lọc dữ liệu" mới có số liệu — trang không tự tải khi mở hay khi đổi ngày. Có số liệu rồi mới bấm được "Xuất Excel". Biểu 02 và 03 cũng theo quy tắc này.',
      placement: "bottom",
    },
    {
      target: "#tour-chung-tu-thu-mua-ho-bieu01",
      title: "Bước 4 · Lọc theo hộ (Biểu 01)",
      content:
        'Dropdown chỉ liệt kê các hộ có phiếu trong khoảng ngày đã lọc (không phải toàn bộ chủ vườn hệ thống). Có thể chọn hộ trước rồi mới lọc — nếu hộ đã chọn không còn trong kỳ mới, hệ thống về "Tất cả hộ".',
      placement: "bottom",
    },
    {
      target: "#tour-chung-tu-thu-mua-xuat-bieu01",
      title: "Bước 5 · Xuất Excel — Biểu 01",
      content:
        'Nút "Xuất Excel" chỉ bấm được sau khi đã "Lọc dữ liệu" thành công. File xuất theo đúng dữ liệu đang xem (đã lọc theo hộ nếu đang chọn 1 hộ).',
      placement: "top",
    },
    {
      target: "#tour-chung-tu-thu-mua-nv-bieu02",
      title: "Bước 6 · Lọc theo nhân viên (Biểu 02)",
      content:
        'Không bắt buộc — để trống xem tất cả nhân viên, hoặc chọn 1 người để lọc riêng. Biểu 02 liệt kê từng PO riêng lẻ (không gộp), sắp theo nhân viên thu mua — chọn nhân viên trước rồi mới bấm "Lọc dữ liệu".',
      placement: "bottom",
    },
    {
      target: "#tour-chung-tu-thu-mua-htx-bieu03",
      title: "Bước 7 · Lọc theo hợp tác xã (Biểu 03)",
      content:
        'Không bắt buộc — để trống xem tất cả, hoặc chọn 1 hợp tác xã/điểm thu mua cụ thể. Nhóm "Ngoài hợp tác xã (mua trực tiếp)" gồm các PO không gắn hợp tác xã nào lúc thu mua.',
      placement: "bottom",
    },
  ];
}

export default buocChungTuThuMua;
